/* eslint-disable no-undef */

import React, { Component } from "react"
import classNames from "classnames"
import ReactDOM from 'react-dom/client';

const closeEnquiry = () => {
	localStorage.removeItem("enquiry-product")
	window.dispatchEvent(new Event("on-storage"))
}

class Widget extends Component {
	   constructor(props) {
			super(props);
			this.state = {
				isCollapsed: sessionStorage.getItem("enquiry-widget-collapsed"),
				items: localStorage.getItem("enquiry-product"),
				isHidden: !localStorage.getItem("enquiry-product"),
			};
			}
	
	componentWillMount = () => {
		this.bodyClasses(localStorage.getItem("enquiry-product"))

		window.addEventListener("on-storage", () => {
			this.setState({
				items: localStorage.getItem("enquiry-product"),
				isHidden: !localStorage.getItem("enquiry-product"),
			})

			this.bodyClasses(localStorage.getItem("enquiry-product"))
		}, false)

		window.addEventListener("on-collapse", () => {
			this.setState({
				isCollapsed: sessionStorage.getItem("enquiry-widget-collapsed"),
			})
		}, false)
	};

	componentClassName = () => classNames("enquiry-widget", {
		"is-collapsed": this.state.isCollapsed,
		"is-not-active": this.state.isHidden,
	});

	collapse = () => {
		sessionStorage.setItem("enquiry-widget-collapsed", true)
		window.dispatchEvent(new Event("on-collapse"))
	};

	expand = () => {
		sessionStorage.removeItem("enquiry-widget-collapsed")
		window.dispatchEvent(new Event("on-collapse"))
	};

	bodyClasses = (items) => {
		if (items) {
			document.body.classList.add("enquiry-has-items")
		} else {
			document.body.classList.remove("enquiry-has-items")
		}
	};

	render() {
		return (
            <div className={this.componentClassName()}>
				{console.log( this.state )}
                { this.state.items ? (
                    <div>
                        <header className="enquiry-widget__header">
                            <h2 className="enquiry-widget__title">Added to Enquiry</h2>
                            <nav className="enquiry-widget__nav">
                                <a href="/products/product-enquiry">Complete</a>

                                {this.state.isCollapsed
                                ? (
                                    <button className="enquiry-widget__btn" onClick={this.expand}>
                                        <svg><use xlinkHref="#chevron-up" /></svg>
                                    </button>)
                                : (<button className="enquiry-widget__btn" onClick={this.collapse}>
                                    <svg><use xlinkHref="#chevron-down" /></svg>
                                </button>)}

                                <button className="enquiry-widget__btn" onClick={closeEnquiry}>
                                    <svg><use xlinkHref="#cross-icon" /></svg>
                                    <div className="enquiry-widget__tooltip">
                                        Delete Enquiry
                                    </div>
                                </button>
                            </nav>
                        </header>
                        <div className="enquiry-widget__list-container">
                            <ul className="enquiry-widget__list">
                                { JSON.parse(this.state.items).map(item => (
                                    <li key={item.code} className="enquiry-widget__item">
                                        <span className="enquiry-widget__count">{ item.count }</span>
                                        <div className="enquiry-widget__name">
                                            <span>{ item.title }</span>
                                            <span>{ item.code }</span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ) : null
            }
            </div>
		)
	}
}
const root = document.getElementById("enquiry-widget")
if (root ) {
	const rootElement = ReactDOM.createRoot( root );
	
	rootElement.render(<Widget />)
}